"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _UndergroundIcon = require("./UndergroundIcon");
Object.keys(_UndergroundIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UndergroundIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UndergroundIcon[key];
    }
  });
});